module.exports = "<h2>{{ user.firstName}} {{ user.lastName }}</h2>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/markl/projects/angularapp/src/app/components/user/user.component.html
// module id = ../../../../../src/app/components/user/user.component.html
// module chunks = main